import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import BootstrapModal from 'shared-components/modal/bootstrap-modal';
import UpdateBookingContainer from '../app-main/containers/UpdateBookingContainer';
import ReviewUpdateContainer from '../app-main/containers/ReviewUpdateContainer';
import { IOSBookingDetails } from '../app-main/components/ios-booking-details-page';

export class UpdateBookingIOSModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      whichModal: ''
    };

    this.closeModal = this.closeModal.bind(this);
    this.renderBody = this.renderBody.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  closeModal () {
    const { accessToken, user, bookingID } = this.props;
    ReactDOM.render(
      <IOSBookingDetails
        accessToken={accessToken}
        SSOID={user.SSOid}
        bookingId={bookingID}
      />, document.getElementById('main-container'));
  }

  closeIosModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  toggleModal (whichModal) {
    this.setState({ whichModal });
  }

  scrollTopIOS () {
    const modal = document.getElementById('custom-offer-form-modal');
    if (modal) {
      modal.scrollTo(0, 0);
    }
  }

  renderBody () {
    const { updateAction, customCb, iosBrowseAddOns } = this.props;
    if ('REQUEST_UPDATE' === updateAction) {
      return (
        <UpdateBookingContainer
          {...this.props}
          closeIOSModal={this.closeModal}
          scrollTopIOS={this.scrollTopIOS}
          finalCb={customCb}
          iosBrowseAddOns={iosBrowseAddOns}
          iosWebView
          toggleModal={this.toggleModal}
          whichModal={this.state.whichModal}
        />
      );
    }

    if ('REVIEW_UPDATE' === updateAction) {
      return (
        <ReviewUpdateContainer
          {...this.props}
          closeIOSModal={this.closeIosModal}
          scrollTopIOS={this.scrollTopIOS}
          finalCb={customCb}
          cancelAction={this.closeIosModal}
          toggleModal={this.toggleModal}
          whichModal={this.state.whichModal}
          iosWebView
        />
      );
    }
    return null;
  }

  render () {
    const { accessToken, updateAction } = this.props;
    if (accessToken && 'REQUEST_UPDATE' === updateAction) {
      return (
        <div id="update-booking-container">
          <div className="update-booking-modal-ios">
            {this.renderBody()}
          </div>
        </div>
      );
    }

    if (accessToken && 'REVIEW_UPDATE' === updateAction) {
      return (
        <BootstrapModal
          showModal
          addCloseIcon={false}
          modalID="custom-offer-form-modal"
          modalSize="lg-size"
          modalType="standard"
          body={this.renderBody()}
        />
      );
    }
  }
}


UpdateBookingIOSModal.propTypes = {
  accessToken: PropTypes.string,
  bookingID: PropTypes.string,
  customCb: PropTypes.func,
  updateAction: PropTypes.string,
  user: PropTypes.object,
  iosBrowseAddOns: PropTypes.bool
};
